import { useEffect, useState } from "react"
import { FaInfoCircle, FaPhone, FaSpinner, FaTimes } from "react-icons/fa"
import { BACKEND } from "../config/configEnvs"
import { toast } from "react-toastify"
import axios from "axios"
import { Pagination } from "@mui/material"
import { useSelector } from "react-redux"
import PaginationItem from "../components/ui/components/Pagination"
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen"
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen"
import CopyToClipBoard from "../utils/CopyToClipBoard"
import IdButton from "../components/ui/components/IdButton"
import Selector from "../components/ui/components/Selector"
import callReasons from "../utils/plainValues/CallReasons"
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';


const RegistroLlamadas = () => {

  const user = useSelector((state) => state.auth.user)
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION"
  const isRrhh = user.puesto.toUpperCase() === "RRHH"
  
  const [limit, setLimit] = useState(50)
  const [page, setPage] = useState(1)

  const [brandName, setBrandName] = useState("")
  const [fechaInicio, setFechaInicio] = useState("")
  const [fechaFin, setFechaFin] = useState("")

  const [calls, setCalls] = useState([])
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [loadingStatus, setLoadingStatus] = useState(false)
  
  const [workers, setWorkers] = useState([])
  const [worker, setWorker] = useState("Todos")

  const [services, setServices] = useState([])
  const [selectedReason, setSelectedReason] = useState("Todos")
  const [selectedService, setSelectedService] = useState("Todos")

  const getServices = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setServices(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const getCalls = async () => {
    try {
      setLoadingStatus(true)

      const baseUrl = `${BACKEND}/api/registroLlamadas`
      let queryParams = {
        limit,
        page,
      }

      if (isAdmin) {
        // queryParams['where[worker][equals]'] = worker

        if (worker !== "Todos") {
          queryParams['where[worker][equals]'] = worker
        }

      } else {
        queryParams['where[worker][equals]'] = user.id
      }

      if (selectedReason !== "Todos") {
        queryParams['where[reason][contains]'] = selectedReason
      }

      if (selectedService !== "Todos") {
        queryParams['where[servicesOfInterest][contains]'] = selectedService
      }

      if (brandName) {
        queryParams['where[client.nombreComercial][like]'] = brandName
      }

      let andFilters = [];
  
      // Fecha: agrupar como and[]
      if (fechaInicio) {
        andFilters.push({
          [`date`]: {
            greater_than_equal: new Date(fechaInicio).toISOString(),
          }
        });
      }
        
      if (fechaFin) {
        andFilters.push({
          [`date`]: {
            less_than_equal: new Date(fechaFin).toISOString(),
          }
        });
      }
  
      // Si hay filtros AND, los agregamos al query
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          queryParams[key] = value;
        });
      }

      const queryString = new URLSearchParams(queryParams).toString();

      const response = await axios.get(`${baseUrl}?${queryString}`);

      setCalls(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (e) {
      console.log(e)
      toast.error("Error al obtener las llamadas: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?where[activo][equals]=true&limit=0`)
      setWorkers(response.data.docs)
    } catch (e) {
      console.log(e)
    }
  }

  const handleSearchClients = () => { // Buscamos clientes y colocamos página 1
    setPage(1)
    getCalls()
  }

  useEffect(() => {
    getCalls()
    getWorkers()
    getServices()
  }, [])

  useEffect(() => {
    getCalls()
  }, [limit, page, worker, fechaInicio, fechaFin, selectedReason, selectedService])

  const formatDate = (dateString) => { // Formateo de fecha y hora en GMT-5
    const date = new Date(dateString);
    if (isNaN(date)) return "Fecha inválida";
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }
  
  const handleResetSearch = () => { // Resetea la búsqueda
    setBrandName(""); // Cambiar el estado
  };

  useEffect(() => { 
    if (brandName === "") {
      setPage(1); 
      getCalls()
    }
  }, [brandName]);

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Header */}
      <div className="flex flex-row px-6 py-2 w-full bg-gray-100 flex flex-row justify-between items-center">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          <div className="flex items-center gap-4 py-4">
              <FaPhone className="text-zinc-700 text-2xl" />
              <h2 className="text-2xl font-bold text-zinc-700">Registro de llamadas</h2>
          </div>
        </div>

        <div className="flex flex-row gap-8 items-center justify-center">

          <div className="flex flex-row items-center justify-center gap-2">
            <span className="text-xs whitespace-nowrap">Límite: </span>
            <select 
              name="limit" 
              id="limit"
              className="text-gray-700 text-xs bg-white border hover:cursor-pointer border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={limit}
              onChange={(e) => setLimit(e.target.value)}
            >   
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={40}>40</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>

          <div className="relative w-full">
            <input
              type="text"
              placeholder="Buscar marca"
              className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              value={brandName}
              onChange={(e) => setBrandName(e.target.value)}
            />
            {brandName && (
              <FaTimes
                onClick={() => handleResetSearch()}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
              />
            )}
          </div>

          <div>
            <Button
              variant="contained"
              endIcon={<SearchIcon />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                padding: "4px 24px",
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
              onClick={() => handleSearchClients()}
            >
              Buscar
            </Button>
          </div>

        </div>

      </div>

      {/* Filtros */}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">
            
            {isAdmin && (
              <Selector
                title="Trabajador" 
                setter={setWorker} 
                value={worker} 
                options={workers.map((s) => {
                  return {
                    value: s.id,
                    label: s.name
                  }
                })} 
                defaultValue="Todos" 
                defaultText="Todos" 
              />
            )}

            <Selector
              title="Motivo de llamada" 
              setter={setSelectedReason} 
              value={selectedReason} 
              options={callReasons.map((s) => {
                return {
                  value: s.value,
                  label: s.label
                }
              })} 
              defaultValue="Todos" 
              defaultText="Todos" 
            />

            <Selector
              title="Servicio de interés" 
              setter={setSelectedService} 
              value={selectedService} 
              options={services.map((s) => {
                return {
                  value: s.name,
                  label: s.name
                }
              })} 
              defaultValue="Todos" 
              defaultText="Todos" 
            />

          </div>
        </div>
      </div>

      {/* Filtros de fecha*/}
      <div className="flex flex-row px-4 bg-gray-100 mt-0.5 mb-0.5">
        <div className="flex flex-row w-full py-1 items-center gap-4 justify-center overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          <div className="flex flex-row w-full gap-4 items-center justify-center px-6">

            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs whitespace-nowrap text-gray-700">
                Fecha inicio
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div> 
            </div>

            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs whitespace-nowrap text-gray-700">
                Fecha fin
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div> 
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          calls.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Trabajador
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Cliente
                  </td>
                  {!isRrhh && (
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                      Número llamado
                    </td>
                  )}
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Fecha y hora
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Audio
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Duración
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Cotizaciones vinculadas
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Notas
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Motivo de llamada
                  </td>
                  <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">
                    Servicios de interés
                  </td>
                </tr>
              </thead>
              <tbody>
                {calls.map((call, i) => {
                  return (
                    <tr key={i} className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 group">
                      <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white z-10 group-hover:bg-gray-100">
                        {call.worker.name}
                      </td>
                      <td scope="row" className="px-2 py-1 border font-bold border-gray-300 truncate text-center bg-white group-hover:bg-gray-100">
                        {call.client?.nombreComercial || "-"}
                      </td>
                      {!isRrhh && (
                        <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white group-hover:bg-gray-100">
                          {call.numberCalled || "-"}
                        </td>
                      )}
                      <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white group-hover:bg-gray-100">
                        {formatDate(call.date)}
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 w-[25rem] text-center bg-white group-hover:bg-gray-100">
                        <div className="w-full h-full">
                          {call.url ? <audio className="w-full h-10" src={call.url} controls /> : "-"}
                        </div>
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                        {call.duration} segs
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 truncate text-center bg-white group-hover:bg-gray-100">
                        <div className="flex w-full flex-row items-center justify-center gap-2">
                          {call.quotes && call.quotes.length > 0 ? (
                            call.quotes.map((q, i) => (
                              <IdButton key={i} content={q.id} action={() => CopyToClipBoard(q.id)} />
                            ))
                          ) : (
                            <span className="text-gray-500">-</span>
                          )}
                        </div>
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                        {call.notes || "-"}
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                        {call.reason || "-"}
                      </td>
                      <td scope="row" className="px-2 py-1 border border-gray-300 text-center bg-white z-10 group-hover:bg-gray-100">
                        {call.servicesOfInterest || "-"}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Paginador */}
      <PaginationItem 
        actualDocs={calls.length}
        totalDocs={totalDocs}
        entity="llamadas"
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  )
}

export default RegistroLlamadas